import { Code2, Database, Cloud, Smartphone, Cpu, Layers } from 'lucide-react';

export default function Technologies() {
  const techCategories = [
    {
      icon: Code2,
      title: 'Frontend Technologies',
      technologies: ['React', 'Angular', 'Vue.js', 'Next.js', 'TypeScript', 'Tailwind CSS']
    },
    {
      icon: Cpu,
      title: 'Backend Technologies',
      technologies: ['Node.js', 'Java/J2EE', 'Python', '.NET', 'PHP', 'Go']
    },
    {
      icon: Cloud,
      title: 'Cloud Platforms',
      technologies: ['AWS', 'Azure', 'Google Cloud', 'Digital Ocean', 'Heroku', 'Kubernetes']
    },
    {
      icon: Database,
      title: 'Databases',
      technologies: ['PostgreSQL', 'MongoDB', 'MySQL', 'Redis', 'Oracle', 'SQL Server']
    },
    {
      icon: Smartphone,
      title: 'Mobile Development',
      technologies: ['React Native', 'Flutter', 'iOS (Swift)', 'Android (Kotlin)', 'Xamarin', 'Ionic']
    },
    {
      icon: Layers,
      title: 'Enterprise Systems',
      technologies: ['SAP', 'Oracle ERP', 'Microsoft Dynamics', 'Salesforce', 'ServiceNow', 'Workday']
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wMyI+PHBhdGggZD0iTTM2IDE2djhoOHYtOHptMCAwdjhoOHYtOHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-40"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-500/10 backdrop-blur-sm border border-blue-400/30 rounded-full mb-4">
            <span className="text-cyan-300 font-semibold text-sm">TECHNOLOGIES & EXPERTISE</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Powered by{' '}
            <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
              Cutting-Edge Technologies
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            We leverage the latest tools, frameworks, and platforms to build robust, scalable solutions that stand the test of time.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {techCategories.map((category, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center mb-6">
                <category.icon className="w-7 h-7 text-white" />
              </div>

              <h3 className="text-2xl font-bold text-white mb-6">{category.title}</h3>

              <div className="flex flex-wrap gap-2">
                {category.technologies.map((tech, idx) => (
                  <span
                    key={idx}
                    className="px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg text-gray-200 text-sm font-medium hover:bg-white/20 transition-colors"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {[
            { number: '50+', label: 'Technologies Mastered' },
            { number: '200+', label: 'Certified Professionals' },
            { number: '10+', label: 'Years Combined Experience' },
            { number: '100%', label: 'Agile Methodology' }
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent mb-2">
                {stat.number}
              </div>
              <div className="text-gray-400">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
